import Axios from "axios";
import {
  SET_ATTENDANCE_LEDGER_REPORT,
  UNSET_ATTENDANCE_LEDGER_REPORT,
} from "@/store/mutation-types";
import {
  getAttendanceLedgerReport,
} from "@/store/api";

const state = {
  attendanceLedgerReport: [],
};

const getters = {
  getAttendanceLedgerReport(state) {
    return state.attendanceLedgerReport;
  },
};

const mutations = {
  [SET_ATTENDANCE_LEDGER_REPORT](state, data) {
    state.attendanceLedgerReport = data;
  },
  [UNSET_ATTENDANCE_LEDGER_REPORT](state) {
    state.attendanceLedgerReport = [];
  },
};

const actions = {
  getAttendanceLedgerReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getAttendanceLedgerReport}`, { params: data })
        .then((response) => {
          commit(SET_ATTENDANCE_LEDGER_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ATTENDANCE_LEDGER_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

